import { Company } from './../../models/Company';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { firestore } from './../../firebase/firebase';

export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';

interface CreateCompanySuccess {
  type: typeof GET_COMPANIES_SUCCESS;
  payload: {
    companies: Company[];
  };
}

const getCompaniesSuccess = (companies: Company[]): CreateCompanySuccess => {
  return {
    type: GET_COMPANIES_SUCCESS,
    payload: { companies },
  };
};

export type CompanyActions = CreateCompanySuccess;

export const getCompanies = () => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    return (
      firestore
        .collection('companies')
        //   .orderBy('timestamp', 'desc')
        .get()
        .then((querySnapshot) => {
          return querySnapshot.docs.map(
            (doc) =>
              new Company(
                doc.id,
                doc.data().applicantName,
                doc.data().icNumber,
                doc.data().contactNumber,
                doc.data().email,
                doc.data().position,
                doc.data().companyName,
                doc.data().ssmNumber,
                doc.data().address,
                doc.data().postcode,
                doc.data().state,
                doc.data().officeNumber,
                doc.data().officeEmail,
                doc.data().recommendedBy,
              )
          );
        })
        .then((companies) => {
          dispatch(getCompaniesSuccess(companies));
        })
    );
  };
};
